import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
function ChevronLeftRegularGlyph(props, svgRef) {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 512", focusable: "false", "aria-hidden": true, ref: svgRef }, props, { children: _jsx("path", { d: "M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z" }, void 0) }), void 0));
}
const ForwardRef = React.forwardRef(ChevronLeftRegularGlyph);
export default ForwardRef;
